<template>
  <div class="zcbody">
    <div class="zc-header">
      <div class="head" style="padding: 20px 0 30px 0">
        <div class="logo">
          <router-link :to="{ path: '/login' }"><img src="../../assets/images/logo.png" style="width: 80px" /></router-link>
        </div>
        <span class="logintext">认养一头牛SRM供应商管理平台</span>
      </div>
    </div>
    <div class="contaner">
      <div class="z_heng">
        <ul>
          <li class="agreement active">
            <img src="../../assets/images/agreement2.png" /><span>注册协议</span>
          </li>
          <li class="information active">
            <img src="../../assets/images/information3.png" /><span>用户信息</span>
          </li>
          <li class="archives active">
            <img src="../../assets/images/archives4.png" /><span>供货信息</span>
          </li>
          <li class="supply-object active">
            <img src="../../assets/images/supply-object5.png" /><span>上传资质</span>
          </li>
          <li class="intelligence active">
            <img src="../../assets/images/intelligence5.png" /><span>注册完成</span>
          </li>
        </ul>
      </div>
      <div class="z_center">
        <div class="z_center1">
          <div class="yonghu" style="
              display: flex;
              justify-content: center;
              text-align: center;
              padding: 30px 50px;
            ">
            <div class="zhucediv">
              <div class="zhuce_p">
                <p>注册成功</p>
              </div>
              <div>
                <img src="../../assets/images//azhuce.png" />
              </div>

              <div class="div_p">

                <p>
                  <span>登录账户：{{formdata.ccustomername}} </span><span style="margin-left: 10px">密码：{{formdata.cpassword}}</span>
                </p><br>

                <p class="titli_p">您的注册信息已经提交请等待审批通过!!!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      urlid: "",
      formdata: {},
    };
  },
  created() {
    this.urlid = this.$route.query.id;
    this.GetSupInfo();
  },
  methods: {
    GetSupInfo() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetSupInfo",
        data: { KeyValue: this.urlid },
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          this.formdata = res.data.Data;
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
  },

  mounted() {},
};
</script>
<style scoped>
@import url(../../assets/css/reg.css);
</style>